/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { VideoEncoding, VideoPreset } from 'livekit-client';
import React, { createContext } from 'react';
import {
  ScreenSharePresetsCalls,
  ScreenShareVideoEncodings
} from '@/context/call-context/screen-share-options.ts';
import { emptyFn } from '@/lib/utils.ts';

interface ScreenShareSettingsContextType {
  selectedSharePreset: VideoPreset;
  setSelectedSharePreset: React.Dispatch<React.SetStateAction<VideoPreset>>;
  selectedEncoding: VideoEncoding;
  setSelectedEncoding: React.Dispatch<React.SetStateAction<VideoEncoding>>;
}

export const ScreenShareSettingsContext = createContext<ScreenShareSettingsContextType>({
  selectedSharePreset: ScreenSharePresetsCalls.h720fps30,
  setSelectedSharePreset: emptyFn,
  selectedEncoding: ScreenShareVideoEncodings.h720p30,
  setSelectedEncoding: emptyFn,
});